module.exports = __webpack_public_path__ + "static/media/bulk_create_consignment.31c352cc.csv";